import { gql } from 'apollo-angular';

const RETRACT_OFFER_PRICING = gql`
  mutation retractOffers($input: RetractOffersRequest!) {
    retractOffers( input: $input ) { 
    success 
    }
  }
`;

export default RETRACT_OFFER_PRICING;
